import { useCallback } from 'react';

import { MessagingStatsData, MessagingStatsQueryParams } from '@partoohub/api-client';
import { UseQueryOptions, useQuery, useQueryClient } from 'react-query';

import { messagingStatsApiClient } from 'app/api/v2/api_calls/apiResources';
import { HOMEPAGE_MESSAGING_STATS } from 'app/common/data/queryKeysConstants';

export const useMessagingStats = (
    params: MessagingStatsQueryParams,
    options?: UseQueryOptions<MessagingStatsData>,
) => {
    return useQuery(
        [HOMEPAGE_MESSAGING_STATS, { params }],
        () => messagingStatsApiClient.getMessagingStats(params),
        options,
    );
};

// returns a function used to refresh homepage and sidebar unanwsered conversations number
export const useInvalidateMessagingStatsQueries = () => {
    const queryClient = useQueryClient();
    const invalidateMessagingStatsQueries = useCallback(() => {
        queryClient.invalidateQueries([HOMEPAGE_MESSAGING_STATS]);
    }, [queryClient]);
    return invalidateMessagingStatsQueries;
};
